import {connect} from "react-redux";
import {global} from "store/global";
import {State} from "../../../store";
import {title} from "store/title";

const mapStateToProps = (state: State) => ({
  carrierRefs: global.selectors.carrierRefs(state),
  operatorRefs: global.selectors.operatorRefs(state),
  territories: global.selectors.projectTerritories(state),
});

const mapDispatchToProps = {
  setHeadBar: title.actions.setHeadBar,
};

export default connect(mapStateToProps, mapDispatchToProps);
